export default __webpack_public_path__ + "static/homepage_footer_background_mobile-99a57e3649e9ff93ddca645d93eb1fc6.png";